import React from 'react';
import { useLocation } from 'react-router-dom';
import { Action, EmptyState, PageBody, Panel } from '../components/aa';

/* An address that leads nowhere says so inside the app, with a way home,
   rather than leaving a blank white page. Home is "/", which sends each role
   to its own start. */
const NotFound: React.FC = () => {
  const { pathname } = useLocation();
  return (
    <PageBody>
      <Panel>
        <EmptyState
          title="Page not found"
          reason={<>There is no page at <span className="break-all font-mono text-[12px] text-ink">{pathname}</span>. It may have moved, or the link may be mistyped.</>}
          action={<Action to="/">Go to your home</Action>}
        />
      </Panel>
    </PageBody>
  );
};

export default NotFound;
